import React from 'react';

interface Props {
  className?: string;
}

const Text: React.FC<Props> = ({ className = '' }: Props) => (
  <svg
    className={className}
    fill="none"
    height="20"
    viewBox="0 0 20 21"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.4856 0.708862L20 6.38771L18.7467 6.72714C18.1593 5.59137 17.5587 4.4556 16.8668 3.88119C16.1749 3.31983 15.3655 3.31983 14.5692 3.31983H11.3055V17.0274C11.3055 17.6801 11.3055 18.3329 11.7363 18.6593C12.1802 18.9856 13.0418 18.9856 13.9164 18.9856V20.2911H6.08355V18.9856C6.95822 18.9856 7.81984 18.9856 8.26371 18.6593C8.69452 18.3329 8.69452 17.6801 8.69452 17.0274V3.31983H5.43081C4.63446 3.31983 3.82506 3.31983 3.13316 3.88119C2.44125 4.4556 1.84073 5.59137 1.25326 6.72714L0 6.38771L1.51436 0.708862H18.4856Z"
      fill="currentColor"
      id="Vector"
    />
  </svg>
);

export default Text;
